/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import AuthService from "../services/AuthService";
import * as authAction from "../actions/auth";
import { Link } from "react-router-dom";
export const userData = localStorage.getItem("persist:root")
  ? JSON.parse(JSON.parse(localStorage.getItem("persist:root")).userData)
  : "";

const required = (value, name) => {
  if (!name.value) {
    return (
      <div className="isaerror" role="alert">
        Please enter your {name.name}
      </div>
    );
  }
};
class ForgotPwd2 extends React.Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    if (userData.token) this.props.history.push({ pathname: "/" });
    this.error = false;

    this.state = {
      username: "",
      password: "",
      authImage: [],
    };
    this.getAuthImage();
  }

  getAuthImage = () => {
    AuthService.getAuthImage()
      .then(result => {
        if (!result) return;
        const authImageLoc = [];

        result.data[0].images?.map((item, index) =>
          authImageLoc.push({
            backgroundImage: `url(${item})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }),
        );
        this.setState({ authImage: authImageLoc });
      })
      .catch(err => {
        console.error(err);
      });
  };

  bgshapestyle = {
    clipPath: "polygon(0 0, 100% 0, 100% 71%, 0% 100%)",
    background: "#00A88A",
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: "0",
    padding: "0 0 1rem 0",
  };

  innerform = {
    zIndex: "9",
    position: "inherit",
    padding: "40px 0",
  };

  loginbox = {
    // background: "#FFFFFF",
    // boxShadow: "6px 4px 21px rgba(0, 0, 0, 0.25)",
    // borderRadius: "20px",
    /* From https://css.glass */
    background: "rgb(255 255 255 / 83%)",
    borderRadius: "16px",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(10.4px)",
    WebkitBackdropFilter: "blur(10.4px)",
    border: "1px solid rgba(255, 255, 255, 0.28)",
  };

  normalhd = {
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "22px",
    lineHeight: "28px",
    color: "rgb(89 89 89)",
    margin: "0",
  };

  colorhd = {
    fontStyle: "normal",
    fontWeight: "800",
    lineHeight: "28px",
    background: "linear-gradient(90deg, #F19755 5.81%, #00A88A 100%)",
    backgroundClip: "text",
    margin: "0",
    textFillColor: "transparent",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };

  benefitGrid = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr 1fr",
    columnGap: "1rem",
    rowGap: "1rem",
    marginTop: "1rem",
    flexGrow: "1",
  };

  gridcell = {
    // border: '1px solid gray',
    // borderRadius: '10px',
    backgroundColor: "white",
    // boxShadow: "rgb(0 133 109) -10px -10px 15px, rgb(0 0 0 / 15%) 10px 10px 15px",
    /* From https://css.glass */
    background: "rgba(255, 255, 255, 0.33)",
    borderRadius: "16px",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(10.4px)",
    WebkitBackdropFilter: "blur(10.4px)",
    border: "1px solid rgba(255, 255, 255, 0.28)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: "8px",
    justifyContent: "center",
    padding: "1rem",
    overflow: "clip",
  };

  render() {
    const { username, password, authImage } = this.state;
    return (
      <div style={{ position: "relative" }}>
        <div className="bgshape" style={this.bgshapestyle}></div>
        <div className="container" style={this.innerform}>
          <form
            className="formRegistration row"
            ref={c => {
              this.form = c;
            }}
            style={{
              minHeight: "40vh",
              zIndex: "9",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/*  */}
            {/*  */}
            {/*  */}
            <div className="col-sm-5">
              {/* below is the form */}
              <section className="agploginbox" style={this.loginbox}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      columnGap: "1rem",
                      minHeight: "40vh",
                      padding: "1.5rem",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* below is the registration heading logos section*/}
                    <div
                      className="agploginbox-header"
                      style={{
                        display: "flex",
                        width: "100%",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={require("../public/grid-logo-1.png")}
                        alt="Ayush grid logo"
                        style={{
                          flexGrow: "1",
                          width: "166px",
                          height: "63px",
                        }}
                      />
                      <div
                        className="mverline-hide"
                        style={{
                          width: "5px",
                          height: "51px",
                          background: "#F09755",
                          borderRadius: "20px",
                        }}
                      ></div>
                      <div
                        className="agplb-signcmt"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flexGrow: "1",
                        }}
                      >
                        <p style={this.normalhd}>
                          Password Recovery
                          <br />
                          <span style={this.colorhd}>Ayush Global Portal</span>
                        </p>
                      </div>
                    </div>
                    {/* <p
                      style={{
                        fontStyle: "italic",
                        fontWeight: "500",
                        fontSize: "13px",
                        color: "#808080",
                        margin: "1rem 0.5rem",
                      }}
                    >
                      Enter your details below to recover your password
                    </p> */}
                    {/* below is the main registration fields */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "1rem",
                      }}
                    >
                      {/* <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "0 0.5rem",
                        }}
                      >
                        <label
                          htmlFor="email"
                          style={{
                            marginBottom: "0.25rem",
                            color: "#9e9e9e",
                            fontSize: "14px",
                          }}
                        >
                          Your email
                        </label>
                        <input
                          type="email"
                          name="email"
                          id="email"
                          value={username}
                          onChange={e =>
                            this.setState({ username: e.target.value })
                          }
                          validations={[required]}
                          style={{
                            background: "#f8f8f8",
                            border: "2px solid #dddddd",
                            padding: "1rem",
                            borderRadius: "14px",
                          }}
                          placeholder="name@company.com"
                          required=""
                        />
                      </div> */}

                      <p
                        style={{
                          padding: "2rem 0.5rem 0",
                          fontSize: "14px",
                          textAlign: "center",
                        }}
                      >
                        If your account exists on Ayush Global Portal, we will
                        send you a mail with further steps.
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "0 0.5rem",
                          rowGap: "8px",
                        }}
                      >
                        <button
                          onClick={e => this.handleLogin(e)}
                          disabled={!(password && username && captchaSuccess)}
                          style={{
                            backgroundColor: "#007e67",
                            borderRadius: "14px",
                            border: "none",
                            padding: "1rem",
                            fontWeight: "600",
                            fontSize: "18px",
                            color: "white",
                          }}
                        >
                          Back to home
                        </button>
                        <p>
                          Already have an account with us?{" "}
                          <a href="/login">Login</a>
                        </p>
                      </div>
                    </div>
                    {/* registration form end */}
                  </div>
                </div>
              </section>
            </div>
            {/*  */}
            {/*  */}
          </form>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return { translation: state.translation };
};
const mapDispatchToProps = dispatch => {
  return {
    userDetail: user => dispatch(authAction.userDetail(user)),
  };
};
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
)(ForgotPwd2);
